// extracted by mini-css-extract-plugin
export default {"typeLabel":"EmailForm_typeLabel__9FtIC"};